export const list = {
  table: {
    id: '順番',
    name: '水洗機表記名',
    type: '水洗機種類',
    typeName: '水洗機種類',
    status: '状態',
    finishedTime: '終了時刻',
    startedTime: '開始時刻',
    working: {
      idle: '待機中',
      inService: '稼働中',
    },
    maintain: 'メンテナンス',
  },
  pageHeader: {
    title: '水洗機リスト　TOP',
    titleMachinesList: '個人データの登録/編集',
    new: '新規',
    import: '水洗機インポート',
    importTank: '洗剤タンクインポート',
  },
}
